<template>
  <div
    class="date-row date-time">
    <div>
      <div class="date-row__label">
        {{ $t('Tenders.To') }}
        <sPopover
          :border="false"
          class="ml-2"
          :content="$t('Automation.DateHint')"
          trigger="hover"
          type="white"
          width="228">
          <sIcon
            slot="reference"
            type="info"/>
        </sPopover>
      </div>
      <TimeSpan
        :disabled="disabled"
        :second="false"
        :value.sync="valueMutable"/>
    </div>
  </div>
</template>
<script>
import TimeSpan from 'components/common/TimeSpan.vue'

export default {
  name: 'automationActionTime',
  computed: {
    valueMutable: {
      get() {
        if (!this.value?.UpdateValue?.trim()) {
          return null
        }
        return this.value?.UpdateValue
      },
      set(newValue) {
        if (newValue !== this.valueMutable) {
          const result = this.$_.cloneDeep(this.value) || {}
          result.UpdateValue = newValue
          this.$emit('update:value', JSON.stringify(result))
        }
      }
    }
  },
  components: {
    TimeSpan
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
  },
}
</script>
<style scoped lang="scss">
.date-row {
  margin-top: 10px;
  display: grid;
  &__label {
    min-height: 16px;
    margin-bottom: 4px;
    display: flex;
    font-size: 0.75rem;
  }
}
.date-time {
    grid-template-columns: 200px 200px;
  }
</style>
